<p-avatar
    [class]="class"
    [image]="('MEDIA_FOLDER_URL' | env) + photo"
    [size]="size"
    [shape]="shape"
    (onImageError)="onError($event, fallbackLabel)"
></p-avatar>
